/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShieldExclamation = createReactComponent("outline", "shield-exclamation", "IconShieldExclamation", [["path", { "d": "M15.04 19.745c-.942 .551 -1.964 .976 -3.04 1.255a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .195 6.015", "key": "svg-0" }], ["path", { "d": "M19 16v3", "key": "svg-1" }], ["path", { "d": "M19 22v.01", "key": "svg-2" }]]);

export { IconShieldExclamation as default };
//# sourceMappingURL=IconShieldExclamation.mjs.map
